import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=43ec1d97&scoped=true&"
import script from "./CardHeader.vue?vue&type=script&lang=ts&"
export * from "./CardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CardHeader.vue?vue&type=style&index=0&id=43ec1d97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ec1d97",
  null
  
)

export default component.exports